function initImageBlockSlider() {
    const sliderWrapper = document.querySelectorAll('.image-blocks__wrapper');
    sliderWrapper.forEach(wrapper => {
        if (!wrapper) return;

        const id = wrapper.dataset.sectionId;
        const container = wrapper.querySelector('#image-blocks-' + id);
        const nextElement = wrapper.querySelector('.swiper-button-next');
        const prevElement = wrapper.querySelector('.swiper-button-prev');

        if (!container) return;

        if (container.swiper) {
            container.swiper.destroy();
        }

        let swiper = new Swiper(container, {
            effect: "slide",
            slidesPerView: 1.075,
            spaceBetween: 16,
            navigation: {
                nextEl: nextElement,
                prevEl: prevElement,
            },
        });
    });
}

document.addEventListener('DOMContentLoaded', function () {
    initImageBlockSlider();
});